import { Dialogs } from '@leverege/ui-elements';
import { Context, Config } from '@leverege/plugin';
import { DataSources } from '@leverege/ui-attributes';
import { AllowedReducer } from '@leverege/api-redux';
import { GlobalState } from '@leverege/ui-redux';
import RecovrSales from '../../util/RecovrSales';
import ChangeVehicleOwnershipDialog from './ChangeVehicleOwnershipDialog';
export default {
  id: 'recovr.changeVehicleOwnership',
  name: 'Change Vehicle Ownership',
  layout: {
    sort: 'recovrSaleActions.changeVehicleOwnership',
    sectionName: 'RecovR Sale Actions'
  },
  matches: [{
    use: ['contextMenu', 'mobileActionBar'],
    path: 'location.sales',
    objectType: 'sale'
  }, {
    use: ['contextMenu', 'mobileActionBar'],
    path: 'sale',
    objectType: 'sale'
  }, {
    use: ['contextMenu', 'mobileActionBar'],
    path: 'company.locations.sales',
    objectType: 'sale'
  }, {
    client: 'MapBoxRolloverSelectionPointer',
    use: ['contextMenu', 'mobileActionBar']
  }],
  prepare: async cxt => {
    const targets = Context.getTargetsOfType(cxt, 'sale');
    if (targets == null || targets.length === 0 || targets.length > 1 || targets[0]?.data?.data?.state !== 'sold' || targets[0]?.data?.data?.type !== 'vehicle-with-locator') {
      return false;
    }
    const parentPath = Config.get('VoidSale', 'saleLocationParentPath', 'location');
    const actions = DataSources.getActions(targets[0]);
    return RecovrSales.canChangeVehicleOwnership({
      saleId: targets[0].id,
      locationId: targets[0].data?.data?.[parentPath]?.id,
      actions
    });
  },
  isPrepared: cxt => {
    const targets = Context.getTargetsOfType(cxt, 'sale');
    if (targets == null || targets.length === 0 || targets.length > 1 || targets[0]?.data?.data?.state !== 'sold' || targets[0]?.data?.data?.type !== 'vehicle-with-locator') {
      return true;
    }
    const a = AllowedReducer.get(GlobalState.get(), targets[0]?.id);
    return a.changeVehicleOwnership != null;
  },
  handles: cxt => {
    const targets = Context.getTargetsOfType(cxt, 'sale');
    if (targets == null || targets.length === 0 || targets.length > 1) {
      return false;
    }
    const a = AllowedReducer.get(GlobalState.get(), targets[0]?.id);
    return a.changeVehicleOwnership === true && targets[0]?.data?.data?.state !== 'void' && targets[0]?.data?.data?.type === 'vehicle-with-locator';
  },
  appearance: () => {
    return {
      name: 'Change Vehicle Ownership',
      icon: 'https://molten-ui-assets.storage.googleapis.com/settings-account.png'
    };
  },
  perform: async props => {
    const {
      context
    } = props;
    const sale = Context.getTargetsOfType(context, 'sale')[0];
    const actions = DataSources.getActions(sale);
    if (!sale) {
      return;
    }
    const locationId = sale?.data?.data?.location?.id;
    const companyId = sale?.data?.data?.company?.id;
    const parentPath = Config.get('VoidSale', 'saleLocationParentPath', 'location');
    const customer = sale?.data?.data?.customer || {};
    const customerEmail = customer?.updatedAccountEmail || customer?.email || 'No current email';
    const customerInfo = await RecovrSales.getCustomerInfo({
      email: customerEmail,
      locationId,
      companyId
    });
    const customerWithExtraInfo = {
      ...customer,
      name: customer?.name || customerInfo?.name,
      phoneNumber: customer?.phoneNumber || customerInfo?.phoneNumber,
      streetAddress: customer?.streetAddress || customerInfo?.streetAddress
    };
    Dialogs.show({
      id: 'changeVehicleOwnership',
      component: ChangeVehicleOwnershipDialog,
      props: {
        sale,
        actions,
        customer: customerWithExtraInfo,
        customerEmail,
        parentPath
      }
    });
  }
};